// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-brand-editor-site-name-card .brand-name {
  font-size: 20px;
  color: var(--fi-color-default);
}
.fi-brand-editor-site-name-card .brand-name.placeholder {
  color: var(--fi-color-light);
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-site-design/fi-site-design-settings/fi-site-design-brand-editor/fi-brand-editor-site-name-card/fi-brand-editor-site-name-card.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,8BAAA;AAAR;AACQ;EACI,4BAAA;AACZ","sourcesContent":[".fi-brand-editor-site-name-card {\r\n    .brand-name {\r\n        font-size: 20px;\r\n        color: var(--fi-color-default);\r\n        &.placeholder {\r\n            color: var(--fi-color-light);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
